import DynamicForm from './dynamicForm';

export default DynamicForm;
